module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp2_5010.0739344d.png";